import { HttpParams } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UTILS } from 'src/app/entities/Utils';
import { Articolo, GenericResponse } from 'src/app/entities/various';
import { ConfigServiceService, ItemSelectProps } from 'src/app/services/config-service/config-service.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { ModalServiceService } from 'src/app/services/modal-service/modal-service.service';
import { ToastService } from 'src/app/services/toast/toast.service';

interface ItemArticolo {
  new : boolean,
  modify : boolean,
  item : Articolo
}

@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.css']
})
export class ItemsComponent implements OnInit {
  
  me : UserInfo | undefined;
  @Input() userId : string | number | undefined;
  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  params : HttpParams;
  articoli : ItemArticolo[] = [];

  listIVA : ItemSelectProps[] = []
  listAliquote : ItemSelectProps[] = [];

  constructor(private configService : ConfigurationService, private loginService : LoginService, private translate : TranslateService,
      private modalService : ModalServiceService, private confService : ConfigServiceService, private toastService: ToastService) { 
        this.params = new HttpParams();
        this.params =this.params.append('endRow', 0);
        this.params =this.params.append('lastKeyVal', '');
        this.params =this.params.append('page', 1);
        this.params =this.params.append('pageDirection', 'FORWARD');
        this.params =this.params.append('pageSize', 12);
        this.params =this.params.append('pagination', true);
        this.params =this.params.append('paginationMode', 'SKIP');
        this.params =this.params.append('rows', 0);
        this.params =this.params.append('searchFilter', '{}');
        this.params =this.params.append('sortDir', 'ASC');
        this.params =this.params.append('sortKey', 'descrizione');
        this.params =this.params.append('startRow', 0);
        this.params =this.params.append('totalPages', -1);
        this.params =this.params.append('totalRows', 0);
        this.innerWidth = window.innerWidth;
        
      }

  async ngOnInit() {
    this.listIVA = (await this.confService.getJSON()).list.listNaturaRitenuta;
    this.listAliquote = (await this.confService.getJSON()).list.listAliquoteIva;
    this.me = JSON.parse(localStorage.getItem("einvuser") || "");
    let data=(await this.configService.getItems(this.userId!, this.params));
    if(data != null ){
      let list = data.data;
      list.forEach((item : Articolo) => this.articoli.push({new: false, modify : false, item : item}))
    }
  }

  async search(filter : string) {
    this.articoli =[];
    this.params= this.params.delete('searchFilter');
    this.params= this.params.append('searchFilter', '{\"descrizione\":\"' + filter +'\"}');
    let list = (await this.configService.getItems(this.userId!, this.params)).data;
    list.forEach((item : Articolo) => this.articoli.push({new : false,modify : false, item : item}))

  }

  async refresh() {
    this.articoli = [];
    this.params= this.params.delete('searchFilter');
    this.params= this.params.append('searchFilter', '{\"descrizione\":\"\"}');
    let list = (await this.configService.getItems(this.userId!, this.params)).data;
    list.forEach((item : Articolo) => this.articoli.push({new: false, modify : false, item : item}))
  }

  modifyItem(item : ItemArticolo) {
    item.modify = true;
  }

  async deleteItem(item : ItemArticolo) {
    let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.delete");
    let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.delete");
    
    let response : GenericResponse;
    if (item.item.id=='') {
      this.articoli.pop();
    } else {
      let check = await this.modalService.openConfirm(label, message);
      if(check) {
        response = await this.configService.deleteItem(this.userId!, item.item.id);
        if(response.success) {
          this.toastService.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.delete.success"), "success");
        } else {
          this.toastService.openToast(response.msg, "warning");
        }
      this.refresh();
      } 
    }
  }

  async save(articolo : ItemArticolo) {
    if(articolo.item.aliquotaiva==0 && articolo.item.natura==''){
      this.toastService.openToast("Correggi aliquota iva e natura", "warning");
      return;
    }
    let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.save");
    let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.save");
    let check = await this.modalService.openConfirm(label, message);
    let response : GenericResponse;
    if(check) {
      if(articolo.new) {
        response = await this.configService.saveNewItem(this.userId!, articolo.item);

      }else {
        response = await this.configService.saveItem(this.userId!, articolo.item);
      }
      
      if(response.success) {
        this.toastService.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.save.success"), "success");
      } else {
        this.toastService.openToast(response.msg, "warning");
      }
      this.refresh();

    }
  }

  addItem() {
    if(this.articoli.filter(e => e.item.id=='').length==0) {
      let newSec : ItemArticolo = {
        new : true,
        modify : true,
        item : {
          id: '',
          user_id : this.userId!,
          aliquotaiva: 0,
          descrizione : '',
          natura : '',
          prezzounitario: 0,
          unitadimisura: ''
         
        }
      }
      this.articoli.push(newSec);
    }
  }

  getPlaceholder(code : string) {
    let response;
    if(code !='') {
      response = this.listIVA.filter(e => e.val==code)[0].label;
    } else {
      response = '';
    }
    return response;
    
  }

}
